import { motion, useReducedMotion } from 'motion/react'
import { MapPin } from 'lucide-react'

export default function FounderBio() {
  const reduceMotion = useReducedMotion()

  return (
    <section id="about" aria-labelledby="about-heading" className="creator-section text-foreground">
      <div id="story" className="creator-container scroll-mt-28">
        <motion.div initial={reduceMotion ? false : { opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: reduceMotion ? 0 : 0.5 }}>
          <p className="creator-label text-muted-foreground">My story / Curiosity, code & craft</p>
          <h2 id="about-heading" className="creator-display mt-4 max-w-4xl text-4xl sm:text-5xl lg:text-7xl">
            I build software as a form of <span className="text-primary">art.</span>
          </h2>
          <div className="mt-10 grid min-w-0 grid-cols-1 gap-5 lg:grid-cols-12">
            <div className="bento-card bg-card p-6 sm:p-9 lg:col-span-7">
              <p className="text-xl font-medium leading-relaxed sm:text-2xl">
                I earned an honors degree in Computer Science specializing in Artificial Intelligence,
                then started working as a software engineer in Sicily in 2011.
              </p>
              <div className="mt-7 space-y-5 text-base leading-8 sm:text-lg">
                <p>
                  I have always seen software as art: logic shaped with imagination, discipline and care.
                  That belief led me from writing code to building companies and products with a life of
                  their own.
                </p>
                <p>
                  My fascination with AI began with clustering algorithms. Over time, I shifted from
                  writing software to building useful business products that turn that curiosity into
                  something people can use.
                </p>
                <p>
                  With Coderblock.ai and our vibe coding platform, I found my niche: making software
                  creation accessible to anyone through AI. In 2025, I moved to San Francisco to fully
                  focus on this mission and pursue the next chapter.
                </p>
              </div>
            </div>
            <div className="grid min-w-0 content-start gap-5 lg:col-span-5">
              <figure className="bento-card overflow-hidden bg-card">
                <img src="/images/san-francisco.jpg" alt="Golden Gate Bridge in San Francisco" width={1600} height={1000} loading="lazy" decoding="async" className="aspect-[16/9] w-full object-cover" />
                <figcaption className="flex items-center gap-2 p-5 text-sm font-medium">
                  <MapPin size={18} aria-hidden="true" className="shrink-0 text-primary" />
                  San Francisco · 201 Spear Street
                </figcaption>
              </figure>
              <div className="bento-card bg-accent p-6 sm:p-8">
                <p className="creator-label">Beyond the screen</p>
                <p className="mt-3 text-lg leading-8">
                  When I step away from the screen, I return to robotics, AOR music and Italian cuisine —
                  three different ways I keep curiosity, rhythm and craft close.
                </p>
              </div>
            </div>
            <figure className="bento-card bg-secondary p-7 sm:p-10 lg:col-span-12">
              <blockquote className="creator-display max-w-5xl text-2xl leading-snug sm:text-3xl lg:text-4xl">
                The idea is simple: you describe what you want, your AI team designs, codes, and ships it. No technical background required.
              </blockquote>
              <figcaption className="creator-label mt-5">In my own words</figcaption>
            </figure>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
